import React, { useContext } from "react";
import useSignUp from "../../../hooks/useSignUp";
import { RolesConstants } from "../../../constants/roles";
import { PixelContext } from '../../../context/Pixel';

export const Join = (props) => {
  const signup = useSignUp();
  const { MetaPixel } = useContext(PixelContext);

  const handleLinkClick = (e, link) => {
    // Fire Meta Lead track only for socials
    if (link) {
      e.preventDefault();
      MetaPixel.track('Lead');

      // It is not possible to determine when fbq has finished.
      // This code does not ensure the event is fired, we may
      // need to relocate the "Lead" event.
      setTimeout(() => {
        window.location.href = link.link;
      }, 300);
    }
  }

  return (
    <div>
      <div className="text-center">
        <div className="container">
          {
            props.data?.linksTitle &&
            <div className="col-md-8 col-md-offset-2 section-title">
              <h2>{props.data?.linksTitle}</h2>
            </div>
          }
        </div>
      </div>
      <div className="container text-center">
        <div className="row my-5">
          {
            props.data?.actions
              ? props.data.actions.map((d, i) => (
                <div key={`action-${i}`} className="col-md-4 my-4">
                  {" "}
                  <div className="service-desc">
                    <h3>
                      <a href={d.link}>{d.title}</a>
                    </h3>
                  </div>
                </div>
              ))
              : "Loading..."
          }
          {
            <div className="col-md-4 my-4">
              {" "}
              <div className="service-desc">
                <h3>
                  <a href={'/auth/login'} onClick={(e) => {
                    e.preventDefault();
                    signup.signupWithRole(RolesConstants.CONTRACTOR);
                  }}
                  >{'Sign Up as a Contractor'}</a>
                </h3>
              </div>
            </div>
          }
          {
            <div className="col-md-4 my-4">
              {" "}
              <div className="service-desc">
                <h3>
                  <span className="d-inline link-pre">
                    Already have an account ?
                  </span>
                  {' '}
                  <a href={'auth/login'} onClick={(e) => {
                    e.preventDefault();
                    signup.signIn();
                  }}
                  >{'Sign In'}</a>
                </h3>
              </div>
            </div>
          }
        </div>
      </div>
      <div className="container text-center">
        <div className="row my-5">
          {
            props.data?.links
              ? props.data.links.map((d, i) => (
                <div key={`links-${i}`} className="col-md-4 my-4">
                  {" "}
                  <a href={d.link} onClick={(e) => handleLinkClick(e, d)}>
                    <i className=""><img className="w-25" alt="" src={require('' + d.image)} /></i>
                  </a>
                  <div className="service-desc">
                    <h3><a href={d.link} onClick={(e) => handleLinkClick(e, d)}>{d.title}</a></h3>
                  </div>
                </div>
              ))
              : "Loading..."
          }

        </div>
      </div>
    </div>
  );
};
